import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';  
import { investorService } from '../services/investorService'; 
import { InvestorState } from '../models/state/investorState';
import { InvestorModel } from '../models/models/investorModel';
import { investorResponse } from '../models/response/investorResponse';
import { InvestorRequest } from '../models/request/investorRequest';

const initialState: InvestorState= {
    investors: {
        token: null,
        status: 'idle',
        isLoading: false,
        error: null,
        message: '',
        blobData: null,
        data:null,
    },
    investorDetails: {
        token: null,
        status: 'idle',
        isLoading: false,
        error: null,
        message: '',
        blobData: null,
        data:null,
    },
    investorList: {
      token: null,
      status: 'idle',
      isLoading: false,
      error: null,
      message: '',
      blobData: null,
      data:null,
  }, 
};
 

export const saveInvestor = createAsyncThunk<
  any,
  { data: any },
  { rejectValue: string }
>(
  " investor/saveInvestor",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await investorService.saveInvestor(data);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
); 

export const getInvestorById = createAsyncThunk<
  InvestorModel,
  { id: number },
  { rejectValue: string }
>(
  "investor/getInvestorById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response =
        await investorService.getInvestorById(id);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
); 

export const registerInvestor = createAsyncThunk<
  any,
  { data: any },
  { rejectValue: string }
>(
  " investor/registerInvestor",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await investorService.registerInvestor(data);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
); 
 
export const getInvestorList = createAsyncThunk<
investorResponse,
  { data: InvestorRequest },
  { rejectValue: string }
>(
  "Investor/getInvestorList",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response =
        await investorService.getInvestorList(data);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
); 

const investorReducer = createSlice({
  name: 'lookup',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveInvestor.pending, (state) => {
        state.investors.status = 'loading';
        state.investors.isLoading = true;
      })
      .addCase(saveInvestor.fulfilled, (state, action) => {
        state.investors.status = 'idle';
        state.investors.data = action.payload;
        state.investors.isLoading = false; 
      })
      .addCase(saveInvestor.rejected, (state, action) => {
        state.investors.status = 'failed';
        state.investors.isLoading= false;
        if (action.payload) {
          state.investors.error = action.payload;
          state.investors.message = action.payload;
        } else {
          state.investors.message = 'An unexpected error occurred';
        }
      })  
      .addCase(getInvestorById.pending, (state) => {
        state.investorDetails.status = 'loading';
        state.investorDetails.isLoading = true;
      })
      .addCase(getInvestorById.fulfilled, (state, action) => {
        state.investorDetails.status = 'idle';
        state.investorDetails.data = action.payload;
        state.investorDetails.isLoading = false; 
      })
      .addCase(getInvestorById.rejected, (state, action) => {
        state.investorDetails.status = 'failed';
        state.investorDetails.isLoading= false;
        if (action.payload) {
          state.investorDetails.error = action.payload;
          state.investorDetails.message = action.payload;
        } else {
          state.investorDetails.message = 'An unexpected error occurred';
        }
      })  
      .addCase(registerInvestor.pending, (state) => {
        state.investors.status = 'loading';
        state.investors.isLoading = true;
      })
      .addCase(registerInvestor.fulfilled, (state, action) => {
        state.investors.status = 'idle';
        state.investors.data = action.payload;
        state.investors.isLoading = false; 
      })
      .addCase(registerInvestor.rejected, (state, action) => {
        state.investors.status = 'failed';
        state.investors.isLoading= false;
        if (action.payload) {
          state.investors.error = action.payload;
          state.investors.message = action.payload;
        } else {
          state.investors.message = 'An unexpected error occurred';
        }
      }) 
      .addCase(getInvestorList.pending, (state) => {
        state.investorList.status = "loading";
        state.investorList.isLoading = true;
      })
      .addCase(getInvestorList.fulfilled, (state, action) => {
        state.investorList.status = "idle";
        state.investorList.data = action.payload;
        state.investorList.isLoading = false;
      })
      .addCase(getInvestorList.rejected, (state, action) => {
        state.investorList.status = "failed";
        state.investorList.isLoading = false;
        if (action.payload) {
          state.investorList.error = action.payload;
          state.investorList.message = action.payload;
        } else {
          state.investorList.message = "An unexpected error occurred";
        }
      }) 
  },
});

export default investorReducer.reducer; 
